<template lang="pug" src="./footer.pug"></template>

<script>
import Icon from 'components/icon/icon'
import { showModal } from 'components/mixins'

export default {
  computed: {
    props () {
      return {
        props: this.$store.state.app.footer
      }
    }
  },
  // created () {
  //   console.log(this.props.props)
  // },
  mixins: [showModal],
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// footer.vue?7a58521c